module.exports = __webpack_public_path__ + "static/media/polaris-book.6cafa7ac.otf";


//////////////////
// WEBPACK FOOTER
// ./src/polaris-book.otf
// module id = ./src/polaris-book.otf
// module chunks = 0